import React, { useState, ChangeEvent, MouseEvent } from "react";
import "./Donation.css";
import donationImage from "../../images/donation_box.png";
import config from "../../config";
import { CartItem, generateUniqueId } from "../../Interfaces/Types";
import { FundraiserParticipantShop } from "../../Interfaces/FundraiserRole";
import AddToCartButton from "./AddToCartButton";

const presetAmounts: number[] = [15, 25, 50, 75, 100, 200];
const donationMinimum = 5;

interface DonationUIProps {
  participantShop: FundraiserParticipantShop;
}

const DonationUI: React.FC<DonationUIProps> = ({ participantShop }) => {
  const [amount, setAmount] = useState<string>("");
  const [customAmount, setCustomAmount] = useState<string>("");
  const DONATION_ID = config.DONATION_ITEM_ID;

  const formatAmount = (value: string) => {
    const numberValue = parseFloat(value);
    if (isNaN(numberValue)) return "";
    return numberValue.toFixed(2);
  };

  const handlePresetClick = (value: number) => {
    const formattedValue = formatAmount(value.toString());
    setCustomAmount(formattedValue);
    setAmount(formattedValue);
  };

  const handleCustomChange = (e: ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;

    const regex = /^(\d*\.?\d{0,2})$/;

    if (regex.test(value)) {
      setCustomAmount(value);
      setAmount(value);
    }
  };

  const donation_item: CartItem = {
    id: generateUniqueId(),
    sku: DONATION_ID,
    name: "Donation",
    price: Number(amount),
    quantity: 1,
    image: donationImage,
  };

  const isDonationValid = amount && parseFloat(amount) >= donationMinimum;

  return (
    <div className="donation-wrapper">
      <div className="donation-header">Make a one-time donation</div>
      <div className="secondary-donation">
        <img
          className="donation-image"
          src={donationImage}
          alt="donation-box"
        />
        <div className="donation-section">
          <div className="preset-header">Quick Donation</div>
          <div className="preset-buttons">
            {presetAmounts.map((value) => (
              <button
                key={value}
                className="preset-button"
                onClick={() => handlePresetClick(value)}
              >
                ${value}
              </button>
            ))}
          </div>
          <div className="custom-amount-header"> Or Enter Custom Amount</div>
          <input
            type="text"
            value={customAmount}
            onChange={handleCustomChange}
            placeholder="Enter amount"
            className="amount-input"
          />
        </div>
        <AddToCartButton
          item={donation_item}
          participant={participantShop}
          buttonText="Donate"
          disabled={!isDonationValid} // Disable the button if the donation is invalid
        />
        {!isDonationValid && (
          <div className="error-message">
            Please enter a valid donation amount (minimum ${donationMinimum}).
          </div>
        )}
      </div>
    </div>
  );
};

export default DonationUI;
